(function () {
    'use strict';

    angular.module('app')
        .factory('Actualidad', Service);

    /* @ngInject */
    function Service($resource) {
        var entidad = "actualidad";
        return $resource('api/' + entidad);
    }

})();
